.column {
	display: flex;
	flex: 0 0 var(--width-column);
	flex-direction: column;

	/* Plain lane — bordered cards carry the structure (Linear/Jira model). */
	& header {
		display: flex;
		gap: var(--spacing-2);
		align-items: center;
		padding: var(--spacing-2) 0 var(--spacing-3);

		& h2 {
			margin: 0;
			font-size: var(--font-size-xs);
			font-weight: var(--font-weight-semibold);
			color: var(--colour-text-secondary);
			text-transform: uppercase;
			letter-spacing: var(--letter-spacing-wide);
		}
	}

	& .count {
		min-inline-size: 1.5rem;
		padding: 0 var(--spacing-2);
		font-size: var(--font-size-xs);
		font-weight: var(--font-weight-semibold);
		font-variant-numeric: tabular-nums;
		line-height: 1.5rem;
		color: var(--colour-text-secondary);
		text-align: center;
		background: var(--colour-background-surface);
		border: 1px solid var(--colour-border-subtle);
		border-radius: var(--radius-full);
	}

	/* Content-width, not the full-width quick-add slot, so it reads as an action. */
	& .archive {
		align-self: flex-start;
		margin-block-end: var(--spacing-2);

		& .archiveIcon {
			inline-size: 0.875rem;
			block-size: 0.875rem;
		}
	}

	& .stack {
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: var(--spacing-2);

		/* Keep an empty column tall enough to read as a lane and be an easy drop target. */
		min-block-size: 4rem;
		padding-block: var(--spacing-2);
		overflow-y: auto;
	}

	& .empty {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
		min-block-size: 4rem;
		margin: 0;
		font-size: var(--font-size-sm);
		color: var(--colour-text-secondary);
		border: 1px dashed var(--colour-border-subtle);
		border-radius: var(--radius-md);
	}
}

/* Phones show one column with the status switcher above it, so the column's own
   name + count header is redundant — hide it. */
@media (width <= 640px) {
	.column > header {
		display: none;
	}
}
